import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseDashboardFiltersComponent } from '../base-dashboard-filters.component';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { GaMessageService } from '../../../../../shared/message/ga-message.service';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { ReportDataService } from '../../../../../shared/report/report-data.service';
import { ReportFiltersUtil } from '../../../../../shared/report/report-filters-util.service';
import { DashboardService } from '../../dashboard.service';
import { Override } from '../../../../../shared/app-decorators';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { GaDeferredService } from '../../../../../shared/services/ga-deferred.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';

@Component({
  selector: 'test-dashboard-filters',
  templateUrl: '../base-dashboard-filters.component.html'
})
export class TestDashboardFiltersComponent extends BaseDashboardFiltersComponent {
  constructor(
    private formlyService:GaFormlyService,
    validateService:GaValidateService,
    messageService:GaMessageService,
    translationService:TranslationService,
    reportDataService:ReportDataService,
    reportFiltersUtil:ReportFiltersUtil,
    dashboardService:DashboardService,
    deferredService:GaDeferredService,
    authService:AuthService,
    cdr:ChangeDetectorRef
  ) {
    super(validateService, messageService, translationService, reportDataService, reportFiltersUtil, dashboardService, deferredService, authService, cdr);
  }

  @Override(BaseDashboardFiltersComponent)
  public createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.anInput('numberOfRows', 'Number of rows')
        .isRequired()
        .withInputType('number')
        .withWrapperClass('col-md-6')
        .build()
    ];
  }
}